import React, { useState } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import { Header, Sidebar } from './index.js';

export const Layout = () => {
  const [, setCurrentDashboardRoute] = useState();
  const location = useLocation();

  const handleUserPreference = () => {
    // Implement user preference action
  };

  const handleLogout = () => {
    // Implement logout action
  };

  return (
    <>
          <main className="main-page-area">
            <Header onUserPreference={handleUserPreference} onLogout={handleLogout} />
            <div className="main-view-area d-flex align-items-start justify-content-start position-relative">
              <Sidebar
                currentDashboardRoute={location.pathname}
                setCurrentDashboardRoute={setCurrentDashboardRoute}
              />
              <div className="main-content main_content_split_new">
                <Outlet />
              </div>
            </div>
          </main>
    </>
  );
};
